export default "__VITE_ASSET__aaa7d85a__"